import React, { useEffect, useState } from "react";
import { Academy } from './academy';
import { Activities } from './activities';
import { Banner } from "./banner";
import { Contact } from "./contact";
import { HowToApply } from './howToApply';
import { ImportantDates } from './importantDates';
import { Navbar } from "./navbar";
import { PlanEstudios } from "./planEstudios";
import {HelmetSEO} from "../../helpers/HelmetSEO";
import { useHistory } from "react-router-dom";

export const CursoAltaEspecialidad = () => {
  const history = useHistory();
  const [showRequirements, setShowRequirements] = useState(false);
  const [showDates, setShowDates] = useState(false);
  // const [showApplyModal, setShowApplyModal] = useState(false);
  useEffect(()=>{
    const navbar = document.getElementById('topNavBar');
    navbar.style.display = "none";
    
    history.push('/');
    return () => {
      // Opcional: Restaura la navbar al desmontar el componente
      if (navbar) navbar.style.display = "block";
    };
  },[history])
  return (
    <>
      <HelmetSEO
        title='Curso de Alta Especialidad en Patología Molecular'
        description='Conoce el plan de estudio del curso de alta especialidad en patología molecular. Aplica ahora y obtén la posibilidad de una beca. Ingresa en Labopat'
      />
      <Navbar/>
      <Banner setShowRequirements={(e)=>setShowRequirements(e)} setShowDates={setShowDates}/>
      <PlanEstudios/>
      <Activities />
      <Academy />
      <HowToApply showRequirements={showRequirements} setShowRequirements={(e)=>setShowRequirements(e)}/>
      <Contact/>
      <ImportantDates showDates={showDates} setShowDates={setShowDates} />
      {/* <ApplyModal showApplyModal={showApplyModal} setShowApplyModal={(e)=>setShowApplyModal(e)}/> */}
    </>
  )
};